module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f910811833cf5437c12d6feac526c62a.png";